import Choices from 'choices.js';
import axios from 'axios';
import { inventoryLocalization } from './translations';

class SearchMini {
  constructor() {
    this.categorySelectEl = document.getElementById('inventory_category');
    this.makeSelectEl = document.getElementById('inventory_make');
    this.modelSelectEl = document.getElementById('inventory_model');
  }

  initialize() {
    this.initCategorySelect();
    this.initMakeSelect();
    this.initModelSelect();

    this.initializeEventListeners();
  }

  initCategorySelect() {
    if (!this.categorySelectEl) {
      return;
    }

    this.categorySelect = new Choices(this.categorySelectEl, {
      itemSelectText: '',
      shouldSort: false,
      classNames: {
        containerInner: 'form-control',
        listSingle: '',
      },
    });
  }

  initMakeSelect() {
    if (!this.makeSelectEl) {
      return;
    }
    this.makeSelect = new Choices(this.makeSelectEl, {
      itemSelectText: '',
      shouldSort: false,
      classNames: {
        containerInner: 'form-control',
        listSingle: '',
      },
    });
  }

  initModelSelect() {
    if (!this.modelSelectEl) {
      return;
    }
    this.modelSelect = new Choices(this.modelSelectEl, {
      itemSelectText: '',
      shouldSort: false,
      classNames: {
        containerInner: 'form-control',
        listSingle: '',
      },
      callbackOnInit: function () {
        this.disable();
      },
    });
  }

  /**
   * Replaces /Removes <option>"Loading..."<option> to the select el
   * @param el HTMLDOMElement
   */
  setLoading(el) {
    if (!el) {
      return;
    }
    el.setChoices(
      [{ value: '', label: `${inventoryLocalization.gettext('Loading')}...` }],
      'value',
      'label',
      true,
    );
    el.setChoiceByValue('');
    el.disable();
  }

  /**
   * Removes the loading option
   * Choices can be provided which is useful for restoring to old state
   * in the event of an error or for updating with new data
   *
   * @param el
   * @param choices (optional) Choices to add.
   * @param value
   * @param label
   */
  removeLoading(el, choices, value, label) {
    if (!el) {
      return;
    }

    el.setChoices(choices ? choices : [], value ? value : 'value', label ? label : '', true);
    el.enable();
  }

  /**
   * TODO: Refactor this and fetchModels to generic searchInventory() method
   * Gets all makes and models.
   * @param categoryId (Optional) Limit response of makes and models by category
   */
  async fetchMakesAndModels(categoryId) {
    const url = new URL('/inventory/search', window.location.href);

    url.searchParams.set('metadata_only', 'true');
    url.searchParams.append('metadata[]', 'make');
    url.searchParams.append('metadata[]', 'model');

    if (categoryId) {
      url.searchParams.append('category', categoryId);
    }

    this.setLoading(this.makeSelect);
    this.setLoading(this.modelSelect);

    const previousModels = this.modelSelect ? this.modelSelect.choices : [];
    const previousMakes = this.makeSelect ? this.makeSelect.choices : [];

    try {
      const { data } = await axios.get(url.toString());
      const models = data.model;
      const makes = data.make;

      this.removeLoading(
        this.makeSelect,
        [{ id: '', name: inventoryLocalization.gettext('All Makes') }, ...makes],
        'id',
        'name',
      );
      this.removeLoading(
        this.modelSelect,
        [{ id: '', name: inventoryLocalization.gettext('All Models') }, ...models],
        'id',
        'name',
      );

      this.modelSelect.setChoiceByValue('');
      this.makeSelect.setChoiceByValue('');
    } catch (e) {
      this.removeLoading(this.modelSelect, previousModels);
      this.removeLoading(this.makeSelect, previousMakes);

      console.warn(
        `${inventoryLocalization.gettext('Unable to fetch inventory makes and models.')} ${
          e.message
        }`,
      );
    }
  }

  /**
   * Fetches a new list of models for a specified make
   * @param makeId ID of the vehicle make
   */
  async fetchModelsForMake(makeId, selectedCategory) {
    const url = new URL('/inventory/search', window.location.href);

    url.searchParams.set('metadata_only', 'true');
    url.searchParams.append('metadata[]', 'model');

    if (makeId) {
      url.searchParams.append('make', makeId);
    }

    if (selectedCategory) {
      url.searchParams.append('category', selectedCategory);
    }

    const oldChoices = this.modelSelect ? this.modelSelect.choices : [];

    this.setLoading(this.modelSelect);

    try {
      const { data } = await axios.get(url.toString());
      const models = data.model;

      this.removeLoading(
        this.modelSelect,
        [{ id: '', name: inventoryLocalization.gettext('All Models') }, ...models],
        'id',
        'name',
      );
      this.modelSelect.setChoiceByValue('');
    } catch (e) {
      this.removeLoading(this.modelSelect, oldChoices);

      console.warn(inventoryLocalization.gettext('Unable to fetch inventory models.'));
      console.error(e);
    }
  }

  initializeEventListeners() {
    let initialLoad = true;

    // Event Listeners
    if (this.categorySelectEl) {
      this.categorySelectEl.addEventListener('change', (event) => {
        const value = event.target.value;

        // Skip since initial load already gets a list of all makes and models.
        // Prevents initial load request from triggering a change event
        if (!value && initialLoad) {
          initialLoad = false;
          return;
        }

        this.fetchMakesAndModels(value);
      });

      this.categorySelectEl.dispatchEvent(new Event('change'));
    }

    if (this.makeSelectEl) {
      this.makeSelectEl.addEventListener('change', (event) => {
        this.fetchModelsForMake(event.target.value, this.categorySelectEl?.value);
      });

      this.makeSelectEl.dispatchEvent(new Event('change'));
    }
  }
}

const searchMiniWidget = new SearchMini();
searchMiniWidget.initialize();
